var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm.reload
      ? _c(
          "div",
          [
            _c("goldDetailTable", {
              attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
              on: {
                "update:goldData": function($event) {
                  _vm.goldData = $event
                },
                "update:gold-data": function($event) {
                  _vm.goldData = $event
                }
              }
            }),
            _vm._v(" "),
            _vm.way == "buyer" &&
            (_vm.fromType ? _vm.fromType == 4 || _vm.fromType == 3 : "true")
              ? _c("goldDetailFlowDetail", {
                  staticStyle: { margin: "30px 0 50px 0" },
                  attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
                  on: {
                    "update:goldData": function($event) {
                      _vm.goldData = $event
                    },
                    "update:gold-data": function($event) {
                      _vm.goldData = $event
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            (_vm.fromType
            ? _vm.fromType == 2 || _vm.fromType == 5
            : "true")
              ? _c("goldDetailFlowRecord", {
                  staticStyle: { margin: "30px 0" },
                  attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
                  on: {
                    "update:goldData": function($event) {
                      _vm.goldData = $event
                    },
                    "update:gold-data": function($event) {
                      _vm.goldData = $event
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("goldDetailOriginInfo", {
              attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
              on: {
                "update:goldData": function($event) {
                  _vm.goldData = $event
                },
                "update:gold-data": function($event) {
                  _vm.goldData = $event
                }
              }
            }),
            _vm._v(" "),
            _c("goldDetailOtherFile"),
            _vm._v(" "),
            _c("goldDetailApproveHistory"),
            _vm._v(" "),
            _vm.backBtn
              ? _c(
                  "div",
                  { staticClass: "spaceCenter" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "btn-blue-line",
                        staticStyle: { margin: "30px 0", width: "100px" },
                        on: {
                          click: function($event) {
                            return _vm.goBack()
                          }
                        }
                      },
                      [_vm._v("返回")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fcff74b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fcff74b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-detail.vue
// module id = 1Gqx
// module chunks = 1